"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var __1 = require("../");
exports.withExperienceEditorChromes = function (WrappedComponent) {
  var Enhancer = /** @class */function (_super) {
    __extends(Enhancer, _super);
    function Enhancer() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
      return _this;
    }
    Enhancer.prototype.componentDidUpdate = function () {
      __1.resetExperienceEditorChromes();
    };
    Enhancer.prototype.render = function () {
      return react_1.default.createElement(WrappedComponent, __assign({}, this.props));
    };
    return Enhancer;
  }(react_1.default.Component);
  return Enhancer;
};